import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import "./Incident.scss";
import incidentTypesGroups from "./IncidentType";

export default function Incident({ incident }) {
  const [name, setName] = useState("");

  useEffect(() => {
    buildDisplayName();
  }, []);

  const { machine, status } = incident;
  const createdAt = incident.created_at;

  function buildDisplayName() {
    const incidentName = incident.incident_type && incident.incident_type.name;
    let displayName = "";
    Object.keys(incidentTypesGroups).forEach((groupKey) => {
      const group = incidentTypesGroups[groupKey];
      Object.keys(group.incidentTypes).forEach((typeKey) => {
        const type = group.incidentTypes[typeKey];
        if (type.name === incidentName) {
          displayName = `${group.displayName} : ${type.displayName}`;
        }
      });
    });
    if (!displayName && incidentName) {
      const parts = incidentName.split(":");
      const [groupPart, ...rest] = parts;
      const typePart = rest.join(":");
      displayName = typePart ? `${groupPart} : ${typePart.toUpperCase()}` : incidentName;
    }
    if (displayName) setName(displayName);
  }

  return (
    <div>
      <Row>
        <Col md={3}>{name}</Col>
        <Col md={2} className={status === "solved" || status === "closed" ? "green" : "red"}>
          {status && status.toUpperCase()}
        </Col>
        <Col md={3}>{machine}</Col>
        <Col md={3}>{createdAt}</Col>
      </Row>
    </div>
  );
}
